import type { MultiLang } from '../config';

interface Props {
    lang: MultiLang;
}

const Footer = (_props: Props) => {
    return (
        <footer className="footer">
            <hr />
            <span className="copyright">Copyright (C) 2018 Neuroinformatics Unit, RIKEN Center for Brain Science</span>
        </footer>
    );
};

export default Footer;
